import { createContext, useContext, useEffect, useState } from 'react'
import useConfigValidator from '../../api/ConfigValidation'

const context = createContext()
export const useConfigs = () => useContext(context)
export default function ConfigProvider({ children }) {
  const [configs, setConfigs] = useState()
  const [loading, setLoading] = useState(true)
  const { getConfigs } = useConfigValidator()

  useEffect(() => {
    getConfigs().then(result => {
      setConfigs(result)
      setLoading(false)
    })
  }, [getConfigs])

  if(loading) return <>{'Carregando'}</>

  return (
    <context.Provider
      value={configs}
    >
      {children}
    </context.Provider>
  )
}

